
export enum CoachAssignmentListKeys {
  functionName = "functionName",
  coachFirstName = "coachFirstName",
  assignmentDate = "assignmentDate",
}

export const CoachAssignmentFormKeys = {
  toBeAssignDate: "coachToBeAssignDate",
  coachAssignments: "coachTypeAssignment",
  coachAssignmentsId:"coachAssignmentId",
} as const;

// base on country code
export const  AllowNoneCoachCountryList: string[] = [
  "country.uk",
  "country.gb"
  // Add more countries as needed
];